<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData">
    <ds-confirmation-link-area>
      <a class="font-weight-semibold" href="javascript:void(0);" (click)="backToPolicies()">{{
        this.backToPoliciesText
      }}</a>
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>

<!-- Header Template -->
<ng-template #headerCellTpl let-column="column">
  <div class="header-cell table-header-cell-wrapper">
    <span
      [ngClass]="{
        'none lg-block': column?.name && column?.shortName,
        block: column?.name && !column?.shortName
      }"
      >{{ column?.name }}</span
    >
    @if (!!column?.shortName) {
      <span class="block lg-none">{{ column?.shortName }}</span>
    }
  </div>
</ng-template>

<!-- Claim Number cell template -->
<ng-template #vehiclePolicyCellTpl let-row="row">
  @if (!!row) {
    <div class="ds-table-body-cell-header-wrapper">
      <div class="block md-none ds-table-body-cell-header">
        <span class="overflow-hidden overflow-ellipsis">
          @if (row.vehicle) {
            <span class="overflow-hidden overflow-ellipsis">{{ row.vehicle }}</span>
          }
          @if (row.policy) {
            <p class="cell-secondary whitespace-nowrap">{{ row.policy }}</p>
          }
        </span>
      </div>
      <div class="none md-block table-body-cell-label-content expandable-cell bordered-cell-first">
        <span class="overflow-hidden overflow-ellipsis">
          @if (row.vehicle) {
            <span class="overflow-hidden overflow-ellipsis">{{ row.vehicle }}</span>
          }
          @if (row.policy) {
            <p class="cell-secondary whitespace-nowrap">{{ row.policy }}</p>
          }
        </span>
      </div>
    </div>
  }
</ng-template>
